$ = window.jQuery;

// render a map
export default obj => {
	const data = obj.data("map");
	if (obj.length && data.key) {
		const map = () => {
			const args = {
				zoom: 16,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				panControl: false,
				zoomControl: false,
				mapTypeControl: false,
				streetViewControl: false,
				disableDefaultUI: true,
				fullscreenControl: false,
				scrollwheel: false,
				styles: [
					{
						featureType: "all",
						elementType: "all",
						// stylers: [
						// 	{
						// 		saturation: -100
						// 	}
						// ]
					}
				]
			};
			obj.each((i, item) => {
				const data = $(item).data("map");
				if (data.lat && data.lng) {
					const latlng = new google.maps.LatLng(data.lat, data.lng);
					args.center = latlng;
					const map = new google.maps.Map(item, args),
						marker = new google.maps.Marker({
							position: latlng,
							map
						});
				}
			});
		};

		if (typeof google === "undefined" || typeof google.maps === "undefined" || typeof google.maps.Map === "undefined") {
			$.ajax("https://maps.googleapis.com/maps/api/js?ver=3&key=" + encodeURIComponent(data.key), {
				success: map,
				dataType: "script",
				cache: false
			});
		} else {
			map();
		}
	}
}
